import { articlesBySlug } from './content/articles';
import type { Article } from './content/articleTypes';

export type SiteRoute =
  | { kind: 'home'; path: '/' }
  | { kind: 'guides'; path: '/conseils' }
  | { kind: 'about'; path: '/a-propos' }
  | { kind: 'tools'; path: '/outils' }
  | { kind: 'tool'; path: string; tool: 'diagnostic-projet' | 'orientation-motorisation' | 'comparateur-cout-global' }
  | { kind: 'privacy'; path: '/confidentialite' }
  | { kind: 'unsubscribe'; path: '/desinscription' }
  | { kind: 'article'; path: string; article: Article }
  | { kind: 'not-found'; path: string };

export const normalizePath = (pathname: string) => {
  const clean = pathname.split('?')[0]?.split('#')[0] || '/';
  if (clean === '/') return '/';
  return `/${clean.replace(/^\/+|\/+$/g, '')}`;
};

export const resolveSiteRoute = (pathname: string): SiteRoute => {
  const path = normalizePath(pathname);
  if (path === '/') return { kind: 'home', path: '/' };
  if (path === '/conseils') return { kind: 'guides', path };
  if (path === '/a-propos') return { kind: 'about', path };
  if (path === '/outils') return { kind: 'tools', path };
  if (path === '/confidentialite') return { kind: 'privacy', path };
  if (path === '/desinscription') return { kind: 'unsubscribe', path };

  const toolMatch = path.match(/^\/outils\/(diagnostic-projet|orientation-motorisation|comparateur-cout-global)$/);
  if (toolMatch) return { kind: 'tool', path, tool: toolMatch[1] as Extract<SiteRoute, { kind: 'tool' }>['tool'] };

  const match = path.match(/^\/conseils\/([^/]+)$/);
  const article = match ? articlesBySlug.get(match[1]) : undefined;
  if (article) return { kind: 'article', path, article };

  return { kind: 'not-found', path };
};
